import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import ROUTES from '../../constants/routes';
import { Spin } from 'antd';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  if (inProgress !== InteractionStatus.None) {
    return <Spin />;
  }

  if (!isAuthenticated) {
    // Save where the user was trying to go, so they can be redirected after login
    return (
      <Navigate
        to={ROUTES.AUTHORIZE}
        state={{ from: location.pathname + location.search + location.hash }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
